/**
 * Bonus rate in percent, e.g. `25` for 2,500 bonus points on 10,000 purchase
 * points.
 *
 * Rounded down: the badge must never promise more than the plan grants.
 */
export const getBonusRate = (purchasePoint: number, bonusPoint: number) => {
  if (purchasePoint <= 0 || bonusPoint <= 0) return 0

  // Multiply before dividing so float error cannot shave off a whole percent
  return Math.floor((bonusPoint * 100) / purchasePoint)
}
